<template>
    <div id="pagos-header">
        <div id="sig-container" class="full form-horizontal">
                <div class="widget">
                    <div class="widget-content widget-content-mini themed-background-info text-light-op"> <span class="float-right text-muted"><i class="fa fa-check"></i></span>Importar información de cambios en el nombre de los deudores</div>
                    <div class="widget-content border-bottom themed-background-muted text-center">
                        <span class="muted-color">Por medio de este módulo se podra cargar la información de los deudores a los cuales deberá realizarse una actualización en el nombre.</span>
                        <hr>
                        <div class="row">
                            <div class="loader" v-if="loading"><i class="fa fa-spinner fa-2x fa-spin text-info"></i></div>
                            <div align="center" class="col-md-12">
                                <div class="row centrar">
                                    <label class="btn btn-primary">
                                        <i class="fa fa-file-excel-o"></i>
                                        <input
											v-on:change="cargarArchivo"
											id="archivo"
											type="file"
											ref="archivo"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                                            style="display: none;">
                                        Seleccionar archivo
                                    </label>
                                    &nbsp;
                                    <a :href="'../files/formato-cambio-nombre.xlsx'" download>
                                        <label class="btn btn-success">
                                            <i class="fa fa-file-excel-o"></i>
                                            Descargar archivo
                                        </label>
                                    </a>
                                </div>
                                <div class="row centrar">
                                    <p>
                                        Si tienes el formato listo para el cargue de cambios de nombre de los deudores, podrás montarlo por medio del boton "Seleccionar archivo". En caso, contrario podras descargar el formato base para montar este cargue por medio de "Descargar archivo".
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
	computed:{
        ...mapGetters({
            'loading': 'informacionContacto/loading'
        }),
	},
    data () {
        return {

        }
    },
    methods: {
        cargarArchivo () {
            let formData = new FormData()
            formData.append('datos', this.$refs.archivo.files[0])
            this.$store.dispatch('informacionContacto/actualizarNombre', formData)
            .then(() => {
                this.$notify({
                    title: 'Archivo procesado',
                    content:'Se ha actualizado con exito el nombre de los deudores.',
                    type: 'success'
                });
            }).catch((error) => {
                this.$notify({
                    title: 'Fallo al importar',
                    content:'Se produjo un error al tratar de importar el archivo, por favor inténtelo mas tarde.'+ error,
                    type: 'danger'
                });
            })
        }
    }
}
</script>

<style>

    .disponibles {
    display: flow-root !important;
    }
    .titulos-disponible {
    padding-left: initial !important;
    padding-right: initial !important;
    }
    .muted-color {
    color: #b9b9b9;
    font-style: italic;
    }

    .centrar {
    display: block;
    }

</style>